import { useCallback } from "react";
import useU2000AxiosAuthenticated from "../u2000Core/axios/U2000UseAxiosAuthenticated";
import { doBeginCorrection } from "./U3130Service";
import type { U3130Timesheet } from "./U3130TimesheetModel";

export function useU3130BeginCorrectionHandlers() {
  const axios = useU2000AxiosAuthenticated();

  const beginCorrection = useCallback(
    async (timesheetId: string, version: number): Promise<U3130Timesheet> => {
      const res = await doBeginCorrection(axios, timesheetId, { id: timesheetId, version });
      const raw = res.data?.result ?? res.data;
      return raw as U3130Timesheet;
    },
    [axios],
  );

  return { beginCorrection };
}
